import React, { useCallback, useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from 'src/components/ui/dialog';
import { clsx } from 'clsx';
import { EditKnowledgeBaseZendeskHelpCenterForm } from './EditKnowledgeBaseZendeskHelpCenterForm';
import { IntegrationSettingsIcon } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/components/CurrentKnowledgeBaseIcons/CurrentKnowledgeBaseIcons';
import { INTEGRATION_NAMES_MAP } from 'src/utils/fileUtils';
import { EditKnowledgeBaseZendeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseIntegrationModal/EditKnowledgeBaseZendeskTicketsForm';
import { EditKnowledgeBaseFreshdeskTicketsForm } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/edit/EditKnowledgeBaseIntegrationModal/EditKnowledgeBaseFreshdeskTicketsForm';

export const EditKnowledgeBaseIntegrationModal = ({
  disabled = false,
  item,
  isOpen = false,
  hideTrigger = false,
  trigger = null,
  knowledgeBaseId = null,
}) => {
  const [open, setOpen] = useState(isOpen);

  useEffect(() => {
    setOpen(isOpen);
  }, [isOpen]);

  const close = () => {
    setOpen(false);
  };

  const renderForm = useCallback(() => {
    switch (item.data.type) {
      case 'zendesk_helpcenter':
        return (
          <EditKnowledgeBaseZendeskHelpCenterForm
            knowledgeBaseId={knowledgeBaseId}
            close={close}
            item={item}
          />
        );
      case 'zendesk_tickets':
        return (
          <EditKnowledgeBaseZendeskTicketsForm
            knowledgeBaseId={knowledgeBaseId}
            close={close}
            item={item}
          />
        );
      case 'freshdesk_tickets':
        return (
          <EditKnowledgeBaseFreshdeskTicketsForm
            knowledgeBaseId={knowledgeBaseId}
            close={close}
            item={item}
          />
        );
    }
  }, [item]);

  return (
    <Dialog onOpenChange={setOpen} open={disabled ? false : open}>
      {!hideTrigger && (
        <DialogTrigger disabled={disabled} asChild>
          {trigger || (
            <button
              className={clsx(
                disabled && 'pointer-events-none opacity-50',
                'flex gap-2 opacity-30 hover:opacity-100 transition',
              )}
            >
              <IntegrationSettingsIcon />
            </button>
          )}
        </DialogTrigger>
      )}
      <DialogContent closeButtonHidden>
        <DialogHeader>
          <DialogTitle>{`${INTEGRATION_NAMES_MAP[item.data.type]} Settings`}</DialogTitle>
        </DialogHeader>
        <div className="grid gap-4 py-4">{renderForm()}</div>
      </DialogContent>
    </Dialog>
  );
};
